export const sortByPriority = (items, direction = 'asc') => [...items].sort((a, b) => direction === 'asc' ? a.priority - b.priority : b.priority - a.priority);